import React, {useEffect, useState} from "react";
import axios from "../../../services/axiosInstance";
import withStoreAuth from "../../../auth/StoreRouteAuth";
import StoreLayout from "./StoreLayout";
import {Btn, Field, Notice, Panel, SectionHead} from "./StoreUI";
import {storeGet} from "../../../services/storeApi";

/**
 * 상점사(쇼핑몰) 메일문의
 *  - 경로 : /store/api/mail
 *  - 기존 사용자 메일문의(UserMailInquiryPg)와 동일한 백엔드(/member/mailInquiry)를 사용하고
 *    입력양식만 상점사 전용(수신 이메일 / 문의내용)으로 대체했다.
 *  - 문의 본문 상단에 상호명·자사URL·담당자를 자동으로 함께 보내
 *    관리자가 어느 상점인지 즉시 알 수 있게 한다.
 */
function StoreMailPg() {

    const [info, setInfo] = useState(null);
    const [receivedMail, setReceivedMail] = useState('');
    const [content, setContent] = useState('');

    const [errors, setErrors] = useState({});
    const [sending, setSending] = useState(false);
    const [sentMsg, setSentMsg] = useState('');

    const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

    // 마운트 시 최초 1회만 상점사 계정 이메일 자동맵핑 (이후 사용자가 변경 가능)
    useEffect(() => {
        storeGet('/store/myInfo')
            .then(res => {
                setInfo(res.data);
                setReceivedMail(prev => (prev ? prev : (res.data?.email || '')));
            })
            .catch(() => setInfo(null));
    }, []);

    const validate = () => {
        const next = {};
        if (!EMAIL_REGEX.test(receivedMail)) next.receivedMail = '답장 받으실 이메일을 정확히 입력해주세요';
        if (!content.trim()) next.content = '문의내용을 입력해주세요';
        setErrors(next);
        return Object.values(next).every(v => !v);
    };

    const sendEmail = async () => {
        if (sending) return;
        setSentMsg('');
        if (!validate()) return;

        setSending(true);
        try {
            await axios.post('/member/mailInquiry/', {
                type: '[비토리지 OpenAPI] 상점사 메일문의',
                helperMail: 'help@btorage.com',
                receivedMail: receivedMail.trim(),
                // 관리자가 어느 상점의 문의인지 바로 알 수 있도록 상호명을 함께 전달
                orderNumber: info?.companyName || '',
                content: `● 상호명 : ${info?.companyName || '-'}\n● 자사 URL : ${info?.storeUrl || '-'}\n● 담당자 : ${info?.name || '-'}\n\n${content}`,
            });
            setContent('');
            setSentMsg('문의를 보냈습니다. 입력하신 메일로 답변드리겠습니다.');
        } catch (e) {
            setErrors({submit: '메일을 보내지 못했습니다. 잠시 후 다시 시도해주세요.'});
        } finally {
            setSending(false);
        }
    };

    return (
        <StoreLayout active="mail"
                     eyebrow="Support"
                     title="메일문의"
                     desc="남겨주신 수신 이메일로 답변드립니다">

            <Panel className="st-rise st-rise-3 tw-max-w-[680px] tw-p-6">
                <SectionHead eyebrow="Inquiry" title="무엇을 도와드릴까요"
                             desc="상호명과 자사 URL, 담당자 정보는 자동으로 함께 전달되니 내용만 적어주세요"/>

                <Field label="수신 이메일" error={errors.receivedMail} required
                       hint="가입하신 이메일이 기본으로 채워집니다. 다른 곳으로 받으시려면 바꿔주세요">
                    <input className="st-input" type="text" value={receivedMail} maxLength={50}
                           placeholder="답변 받으실 이메일을 입력해주세요"
                           onChange={(e) => setReceivedMail(e.target.value)}/>
                </Field>

                <Field label="문의내용" error={errors.content} required>
                    <textarea className="st-textarea st-scroll" value={content} rows={11} maxLength={4000}
                              placeholder={"문의하실 내용을 자유롭게 남겨주세요.\n\n예) API 버튼 삽입 방법이 궁금합니다.\n예) 특정 상품이 연동되지 않습니다."}
                              onChange={(e) => setContent(e.target.value)}/>
                    <div className="tw-mt-1.5 tw-flex tw-justify-end">
                        <span className="st-num tw-text-[11.5px] tw-text-[color:var(--st-text-faint)]">
                            {content.length} / 4000
                        </span>
                    </div>
                </Field>

                {errors.submit ? <div className="tw-mb-3"><Notice tone="warn">{errors.submit}</Notice></div> : null}
                {sentMsg ? <div className="tw-mb-3"><Notice tone="done">{sentMsg}</Notice></div> : null}

                <Btn tone="dawn" size="lg" className="tw-mt-2 tw-w-full" onClick={sendEmail}
                     disabled={sending} busy={sending}>
                    문의 보내기
                </Btn>
            </Panel>
        </StoreLayout>
    );
}

export default withStoreAuth(StoreMailPg);
